import type { BenchMachineSummary } from "./benchesApi";

export function benchDisplayLabel(bench: Pick<BenchMachineSummary, "machineId">): string {
  return bench.machineId.trim();
}
